<template>
<transition name="slide">
    <div  :class="temp.type==1&&temp.getViewLogCount&&temp.getViewLogCount!=1?'view-log-min-footer':'view-log-info-footer'" v-show="clickCurrent==index">
        <div v-if="temp.type==1">
            <div class="log-line" v-if="showStatus(temp)=='success'">{{$t('language.common.result')}}: {{$t('language.common.success')}}</div>
            <div class="log-line" v-if="showStatus(temp)=='failure'">{{$t('language.common.result')}}:{{$t('language.common.failure')}}</div>
            <div class="log-line" v-if="showStatus(temp)=='partialSuccess'">{{$t('language.common.result')}}:{{$t('language.common.partialSuccess')}}</div>
             <div class="log-line" v-if="showStatus(temp)=='cancel'">{{$t('language.common.result')}}:{{$t('language.common.canceled')}}</div>
            <div v-if="temp.lastLog">
            <div class="log-line" v-if="temp.branchType!='businessTransfer'">
                <div class="log-single-left">{{$t('language.common.fileProcess')}}:{{temp.lastLog.readyTranFileCount}}/{{temp.lastLog.totalFileCount}}</div>
                <div class="log-single-right">{{$t('language.common.dataProcess')}}: {{temp.lastLog.fileTotalReadedBytes|formatByte}}/{{temp.lastLog.totalBytes|formatByte}}</div>
            </div>
            <div class="log-line" v-if="temp.branchType=='businessTransfer'">
                <div class="log-single-left" style="width:100%;">{{$t('language.common.fileProcess')}}:{{temp.lastLog.readyTranFileCount}}/{{temp.lastLog.totalFileCount}}</div>
            </div>
             <div class="log-line" v-if="temp.branchType=='businessTransfer'">
                <div class="log-single-left" style="width:100%;">{{$t('language.common.dataProcess')}}:{{temp.lastLog.fileTotalReadedBytes|formatByte}}/{{temp.lastLog.totalBytes|formatByte}}</div>
            </div>
            <div class="log-line" >
                <div class="log-single-left">{{$t('language.common.startTime')}}:{{temp.lastLog.taskStartTimeStr}}</div>
                <div class="log-single-right">{{$t('language.common.endTime')}}:{{temp.lastLog|getEndTime}}</div>
            </div>
            <div class="log-line">
                <div class="log-single-left" >{{$t('language.common.averageRateSpecial')}}: {{(temp.lastLog.fileTotalReadedBytes/(temp.lastLog.taskElaspedTimeLong/1000))|formatByteSpeed}}</div>
                <div class="log-single-right">{{$t('language.common.executedTimes')}}:{{temp.runCount}}</div>
            </div>
            <div class="log-line" v-if="temp.lastLog&&temp.lastLog.totalBytes&&temp.lastLog.fileTotalReadedBytes==temp.lastLog.totalBytes&&temp.lastLog&&!temp.lastLog.errorList.length">
                {{$t('language.common.fileSuccess')}}
            </div>
            <div class="log-line" v-if="temp.lastLog&&temp.lastLog.errorList.length">
                <div class="log-failed-left click-log-red" @click="openFailedFiles()">
                    {{$t('language.common.viewFailed')}}
                </div>
                <div class="log-retry-right click-log-blue" v-if="!temp.retryed" @click="retryAll(temp)">
                    {{$t('language.common.retryAll')}}
                </div>
                <div class="log-retry-right click-log-blue" v-if="temp.retryed" @click="toAimRootCatalog(temp)">{{$t('language.common.viewProgress')}}</div>
            </div>
            <div class="log-failed-left " style="color:red;" v-if="temp.lastLog&&temp.lastLog.response=='Not enough data traffic for cloud to cloud transmission'">
                {{$t('language.taskList.notTraffic')}}
            </div>
            </div>
            <div v-if="!temp.lastLog&&temp.getViewLogCount==1&&temp.branchType!='businessTransfer'" style="float: left;margin-top: 5Px;color:#4281FF">
                 <div>{{$t('language.common.loadData')}}<span class="loadViewLogs"></span></div>
            </div>
        </div>
        <div v-if="temp.type==2">
            <div class="log-line" v-if="showStatus(temp)=='success'">{{$t('language.common.result')}}: {{$t('language.common.success')}}</div>
            <div class="log-line" v-if="showStatus(temp)=='failure'">{{$t('language.common.result')}}:{{$t('language.common.failure')}}</div>
            <div class="log-line" v-if="showStatus(temp)=='partialSuccess'">{{$t('language.common.result')}}:{{$t('language.common.partialSuccess')}}</div>
             <div class="log-line" v-if="showStatus(temp)=='cancel'">{{$t('language.common.result')}}:{{$t('language.common.canceled')}}</div>
            <div v-if="temp.lastLog">
            <div class="log-line" v-if="temp.lastLog">
                <div>{{$t('language.common.fileProcess')}}:Add[{{temp.lastLog.addFile}}]&nbsp;Update[{{temp.lastLog.updateFile}}]&nbsp;Delete[{{temp.lastLog.deleteFile}}]</div>
            </div>
             <div class="log-line" v-if="temp.lastLog">
                <div >{{$t('language.common.dataProcess')}}: {{temp.lastLog.fileTotalReadedBytes|formatByte}}/{{temp.lastLog.totalBytes|formatByte}}</div>
            </div>
            <div class="log-line" v-if="temp.lastLog">
                <div class="log-single-left">{{$t('language.common.startTime')}}:{{temp.lastLog.taskStartTimeStr}}</div>
                <div class="log-single-right">{{$t('language.common.endTime')}}:{{temp.lastLog|getEndTime}}</div>
            </div>
            <div class="log-line">
                <div class="log-single-left" v-if="temp.lastLog">{{$t('language.common.averageRateSpecial')}}: {{(temp.lastLog.fileTotalReadedBytes/(temp.lastLog.taskElaspedTimeLong/1000))|formatByteSpeed}}</div>
                <div class="log-single-right">{{$t('language.common.executedTimes')}}:{{temp.runCount}}</div>
            </div>
            <div class="log-line" v-if="temp.lastLog&&temp.lastLog.totalBytes&&temp.lastLog.fileTotalReadedBytes==temp.lastLog.totalBytes">
                {{$t('language.common.fileSuccess')}}
            </div>
            <div class="log-line" v-if="temp.lastLog&&temp.lastLog.errorList.length">
                <div class="log-failed-left click-log-red" @click="openFailedFiles()">
                    {{$t('language.common.viewFailed')}}
                </div>
            </div>
            <div class="log-failed-left " style="color:red;" v-if="temp.lastLog&&temp.lastLog.response=='Not enough data traffic for cloud to cloud transmission'">
                {{$t('language.taskList.notTraffic')}}
            </div>
            </div>
            <div v-else style="float: left;margin-top: 5Px;color:#4281FF">
                 <div>{{$t('language.common.loadData')}}<span class="loadViewLogs"></span></div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    props: ['clickCurrent', 'index', 'itemDetail'],
    data: function () {
        return {

        }
    },
    computed:{
      temp:{
        get: function () { return this.itemDetail },
        set: function (val) { return val }
      }
     },
    methods: {
        updatePage(itemDetail){
           this.temp=itemDetail;
           this.$forceUpdate();
        },
        openFailedFiles() {
            let that = this;
            let failedFilesDialog = this.$parent.$parent.$refs.failedFilesDialog;
            failedFilesDialog.retryFailedShow = true;
            failedFilesDialog.selectedArr = [];
            failedFilesDialog.transferType = this.itemDetail.type;
            failedFilesDialog.unfinishData = this.itemDetail.lastLog.errorList;
            $.each(failedFilesDialog.unfinishData, function (index, item) {
                item.fromItem = that.itemDetail.fromItem;
                item.toItem = that.itemDetail.toItem;
            });
        },
        retryAll(itemDetail) {
            let that = this;
            let failedFilesDialog = this.$parent.$parent.$refs.failedFilesDialog;
            let errorList = itemDetail.lastLog.errorList;
            failedFilesDialog.selectedArr = Object.assign([], errorList);
            failedFilesDialog.unfinishData = Object.assign([], errorList);
            $.each(failedFilesDialog.selectedArr, function (index, item) {
                item.fromItem = Object.assign([], itemDetail.fromItem);
                item.toItem = Object.assign([], itemDetail.toItem);
            });
            failedFilesDialog.retry();
            itemDetail.retryed = true;
            that.$forceUpdate();

        },
        toAimRootCatalog(itemDetail) {
            let toItem = itemDetail.toItem;
            let toItemJson = Object.assign({}, toItem);
            let rootNodes = toItemJson.nodes[toItemJson.nodes.length - 1];
            toItemJson.nodes = [];
            toItemJson.nodes.push(rootNodes);
            toItemJson.id = toItemJson.nodes[toItemJson.nodes.length - 1].fileId;
            if (toItemJson.nodes[toItemJson.nodes.length - 1].filename) {
                toItemJson.name = toItemJson.nodes[toItemJson.nodes.length - 1].filename;
            } else {
                toItemJson.name = toItemJson.nodes[toItemJson.nodes.length - 1].fileName;
            }
            this.$parent.$parent.toAimCatalog(toItemJson);
        },
           showStatus(item){
            let result=taskListUtils.showStatus(item);
            return result;
        },

    },
}
</script>

<style>
.loadViewLogs {
  font-family: sans-serif;
  display: inline-block;
  width: 10px; /*no*/
  min-height: 2px; /*no*/
  padding-right: 2px; /*no*/
  border-left: 2px solid currentColor; /*no*/
  border-right: 2px solid currentColor; /*no*/
  background-color: currentColor;
  background-clip: content-box;
  box-sizing: border-box;
  -webkit-animation: dot 4s infinite step-start both;
  animation: dot 1s infinite step-start both;
}

.loadViewLogs:before {
  font-family: sans-serif;
  content: '...';
}

/* IE8 */
.loadViewLogs::before {
  font-family: sans-serif;
  content: '';
}

:root .loadViewLogs {
  margin-left: 2px; /*no*/
  padding-left: 2px; /*no*/
}
.view-log-info-footer {
    width: 100%;
    height: 160px;
    /*no*/
    float: left;
    line-height: 20px;
    /*no*/
    font-size: 13px;
    /*no*/
    box-sizing: border-box;
    padding-top: 10px;
    /*no*/
}
.view-log-min-footer {
    width: 100%;
    height: 100px;
    /*no*/
    float: left;
    line-height: 20px;
    /*no*/
    font-size: 13px;
    /*no*/
    box-sizing: border-box;
    padding-top: 10px;
    /*no*/
}


.log-single-left {
    float: left;
    width: 200px;
    /*no*/
}

.log-single-right {
    float: left;
    width: 245px;
    /*no*/
}

.log-failed-left {
    float: left;
    margin: 10px 10px 0 0;
    /*no*/
}

.log-retry-right {
    float: left;
    margin-top: 10px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_detailed_progress/tab_logs_detail.vue